export default function ($translate) {
    return {
        KEYS: {
            SEQUENCE: 'SEQUENCE',
            ANY: 'ANY'
        },
        LABELS: {
            SEQUENCE: $translate.instant('course.Sequence'),
            ANY: $translate.instant('course.Any')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/trainingOrderType/index.js